import {Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import React, {Component} from "react";
import Select from "react-select";
import "react-select/dist/react-select.min.css"
import {getData, postData} from "../../api/doLogin";
import {saveCSV, setFormFieldValue} from "../Applications/shared/shared";
import {stringify} from "query-string-es5-strict";
import {toast} from "react-toastify";

export class TrainingHistoryDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      totalResults: 0,
      optionsUsers: [],
      selectedUsers: [],
      optionsCategories: [],
      selectedCategories: [],
      optionsTrainings: [],
      selectedTrainings: [],
      formData: {},
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      showIndicator: false,
      showDialog: true,
    }
  }

  componentDidMount() {
    this.getOptions();
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   // like writing return true
  //   return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  // }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  grabDateTime(dateStr, timeStr, defaultTime) {
    if (!dateStr) return "";
    if (dateStr.length === 0) return "";
    if (!timeStr || timeStr.length === 0) timeStr = defaultTime;
    return `${dateStr} ${timeStr}`
  }

  saveUserList() {
    let self = this;
    let data = {
      start: this.grabDateTime(this.state.startDate, this.state.startTime, "00:00"),
      end: this.grabDateTime(this.state.endDate, this.state.endTime, "23:59"),
      users: this.state.selectedUsers,
      categories: this.state.selectedCategories,
      trainings: this.state.selectedTrainings,
    };
    let queryString = stringify(data, {arrayFormat: "bracket"});
    getData(`training/history/request?${queryString}`, {}, this.props.token)
      .then((data) => {
        // console.log(data.data);
        // return;
        if (data.status === "Success") {
          toast.success("Saving Data...")
          saveCSV(data.data, `training-report-${new Date()}.csv`)
          //   self.props.onClose && self.props.onClose();
        } else {
          //
          toast.error("There was an error.")
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getOptions() {
    let self = this;
    getData(`training/history/options`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({
            optionsUsers: data.data.users.map((user) => {
              return {
                value: user.id,
                label: `${user.lname}, ${user.fname}`,
                visible: user.visible,
                perms: user.perms,
              }
            }).sort((userA, userB) => userA.label > userB.label ? 1 : -1),
            optionsCategories: data.data.categories.map((cat) => {
              return {
                value: cat.id,
                label: `${cat.display}`,
              }
            }),
            optionsTrainings: data.data.trainings.map((cat) => {
              return {
                value: cat.id,
                label: `${cat.title}`,
                category: cat.category
              }
            }),
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  hasTrainingPerms(permission) {
    let trainingPermission = "training";
    if (permission[trainingPermission]) {
      return (permission[trainingPermission].length > 0 && (permission[trainingPermission].includes(1) || permission[trainingPermission].includes(2)));
    }
    return false;
  }

  render() {
    const validUserOptions = this.state.optionsUsers.filter((option) =>
      (option.visible === 1 || this.state.selectedUsers.indexOf(option.value) > -1) && this.hasTrainingPerms(option.perms));
    const validCategoryOptions = this.state.optionsCategories;

    function getCatDisplay(catId) {
      let returnOption = validCategoryOptions.find((option) => option.value === catId);
      return returnOption ? returnOption.label : "";
    }

    const validTrainingOptions = this.state.optionsTrainings.filter((option) => this.state.selectedCategories.includes(option.category)).map((option) => this.state.selectedCategories.length < 2 ? option : {
      ...option,
      label: `${getCatDisplay(option.category)}-${option.label}`
    });

    return (
      <React.Fragment>
        {this.state.optionsUsers.length > 0 && (
          <Modal isOpen={true}
                 className={'modal-md ' + this.props.className}>
            <ModalHeader>{this.props.title}</ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label htmlFor="selectedStart">Starting At (Empty means all)</Label>
                <input type={"date"} value={this.state.startDate}
                       onChange={(event => this.setState({startDate: event.target.value}))}/>
                <input type={"time"} value={this.state.startTime}
                       onChange={(event => this.setState({startTime: event.target.value}))}/>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="selectedEnd">Ending by (Empty means all)</Label>
                <input type={"date"} value={this.state.endDate}
                       onChange={(event => this.setState({endDate: event.target.value}))}/>
                <input type={"time"} value={this.state.endTime}
                       onChange={(event => this.setState({endTime: event.target.value}))}/>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="selectedUsers">Filter Users (Empty means all)</Label>
                <Select
                  id="selectedUsers"
                  name="selectedUsers"
                  value={this.state.selectedUsers}
                  options={validUserOptions}
                  onChange={(accessPerms) => this.setState({selectedUsers: accessPerms.map(r => r.value)})}
                  multi
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="selectedUsers">Filter Categories (Empty means all)</Label>
                <Select
                  id="selectedCategories"
                  name="selectedCategories"
                  value={this.state.selectedCategories}
                  options={validCategoryOptions}
                  onChange={(accessPerms) => this.setState({
                    selectedCategories: accessPerms.map(r => r.value),
                    selectedTrainings: accessPerms.length === 0 ? [] : this.state.selectedTrainings
                  })}
                  multi
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="selectedUsers">Filter Videos (Empty means all)</Label>
                <Select
                  id="selectedTrainings"
                  name="selectedTrainings"
                  value={this.state.selectedTrainings}
                  disabled={this.state.selectedCategories.length === 0}
                  options={validTrainingOptions}
                  onChange={(accessPerms) => this.setState({selectedTrainings: accessPerms.map(r => r.value)})}
                  multi
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="info"
                      onClick={() => this.saveUserList()}>Get</Button>
              <Button color="secondary"
                      onClick={() => this.props.onClose()}>Close</Button>
            </ModalFooter>
          </Modal>
        )}

      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Training/TrainingHistoryDialog.js